module.exports = __webpack_public_path__ + "img/INNBeauty2.cf550a42.jpg";